import React from 'react';
import {
  Alert,
  Icons,
  useTheme,
  AULA_LIGHT_ALERT_INFO_BG_COLOR,
  AULA_DARK_ALERT_INFO_BG_COLOR,
} from '@ublend-npm/aulaui-core';

type Props = {
  title: string;
  children: React.ReactNode;
  sx?: object;
};

const InfoAlert = ({ title, children, sx }: Props) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Alert
      severity="info"
      icon={<Icons.InfoOutlined fontSize="small" />}
      sx={{
        bgcolor: isDark
          ? AULA_DARK_ALERT_INFO_BG_COLOR
          : AULA_LIGHT_ALERT_INFO_BG_COLOR,
        border: 'none',
        borderRadius: '8px',
        alignItems: 'flex-start',
        '& .MuiAlert-icon': {
          color: isDark ? '#29B6F6' : '#0288D1',
          marginTop: '1px',
        },
        '& .MuiAlert-message': {
          fontFamily: theme.typography.fontFamily,
          fontWeight: theme.typography.fontWeightRegular,
          fontSize: '0.875rem',
          lineHeight: '143%',
          letterSpacing: '0px',
          color: isDark ? '#B8E7FB' : '#014361',
          '& a': {
            color: isDark ? '#D0BCFA' : '#014361',
          },
        },
        ...sx,
      }}
    >
      <span>
        <span
          style={{
            display: 'block',
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: '1rem',
            lineHeight: '150%',
            letterSpacing: '0.15px',
          }}
        >
          {title}
        </span>
        <span style={{ display: 'block', marginTop: '2px' }}>{children}</span>
      </span>
    </Alert>
  );
};

export default InfoAlert;
